import React from "react";
import Header from "../../components/ui/Header";
import SidebarComponents from "../../components/ui/SidebarComponents";
import HistoryTransactionDashboard from "../../components/screen/dashboard/HistoryTransactionDashboard";
import { SIDEBAR_WIDTH } from "../../components/constants/constant";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const HistoryTransactionDashboardPage = () => {
  return (
    <div className="">
      <PageTemplate
        header=""
        mainComponent={
          <ThemeProvider theme={theme}>
            <div className="text-[12px]">
              <HistoryTransactionDashboard />
            </div>
          </ThemeProvider>
        }
        checkOwner={true}
      />
    </div>
  );
};

export default HistoryTransactionDashboardPage;
